/**
 * 获取用户名的首字母作为默认头像
 * @param name 用户名
 * @returns 首字母（大写）
 */
export function getInitials(name: string | undefined): string {
	if (!name || name.trim().length === 0) {
		return "U";
	}

	// 如果用户名包含空格，取第一个和最后一个单词的首字母
	const words = name.trim().split(/\s+/);
	if (words.length > 1) {
		return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
	}

	// 否则只取第一个字符
	return name.charAt(0).toUpperCase();
}

/**
 * 检查头像URL是否有效
 * @param avatarUrl 头像URL
 * @returns 是否有效
 */
export function isValidAvatarUrl(avatarUrl: string | undefined): boolean {
	if (!avatarUrl || avatarUrl.trim().length === 0) {
		return false;
	}

	// 检查是否是有效的URL格式
	try {
		new URL(avatarUrl);
		return true;
	} catch {
		// 如果不是完整URL，检查是否是相对路径或base64
		return avatarUrl.startsWith("/") || avatarUrl.startsWith("data:");
	}
}
